import { create } from "zustand";
import { getSession } from "../services/authApi";

const useAuthStore = create((set) => ({
	authenticated: false,
	profile: null,
	userId: null,
	initialized: false,
	loading: false,
	error: "",

	setProfile: (profile) =>
		set({
			authenticated: Boolean(profile),
			profile: profile || null,
			userId: profile?.id || null,
			error: "",
		}),

	clearAuth: () =>
		set({
			authenticated: false,
			profile: null,
			userId: null,
			error: "",
		}),

	bootstrapSession: async () => {
		set({ loading: true, error: "" });
		try {
			const payload = await getSession();
			set({
				authenticated: Boolean(payload.authenticated),
				profile: payload.profile || null,
				userId: payload.profile?.id || null,
				initialized: true,
				loading: false,
				error: "",
			});
		} catch (err) {
			set({
				authenticated: false,
				profile: null,
				userId: null,
				initialized: true,
				loading: false,
				error: err.message || "Failed to load session",
			});
		}
	},

	revalidateSession: async () => {
		try {
			const payload = await getSession();
			set({
				authenticated: Boolean(payload.authenticated),
				profile: payload.profile || null,
				userId: payload.profile?.id || null,
				error: "",
			});
		} catch {
			set({
				authenticated: false,
				profile: null,
				userId: null,
				error: "",
			});
		}
	},
}));

export default useAuthStore;